import produce from 'immer';
import { useAuthStateStore } from '@annunciate/core';
import { storage } from '@annunciate/core/dist/store/mmkv-store';
import { getMappedURI } from '../getMappedURI';
import { multiKeyValueMap } from './multiKeyValueMap';
export const DOWNLOAD_CACHE_KEY = 'downloads';
const getUUID = useAuthStateStore.getState().getUUID;
export const onSuccessfulDownloadMutateCache = ({ client, items, uuid: defaultUUID, assetDestination, coverDestination, }) => {
    if (!assetDestination && !coverDestination) {
        return;
    }
    const uuid = defaultUUID ? defaultUUID : getUUID(true);
    const updatedItems = items.map((item) => {
        const cachedItem = client.getQueryData([
            `${DOWNLOAD_CACHE_KEY}:${uuid}`,
            { id: item.id },
        ]);
        return produce(cachedItem || item, (draft) => {
            if (assetDestination) {
                draft.asset.src = getMappedURI(assetDestination);
            }
            if (coverDestination) {
                draft.cover.src = getMappedURI(coverDestination);
            }
        });
    });
    client.setQueryData([DOWNLOAD_CACHE_KEY], (input) => {
        return produce(input || [], (draft) => {
            draft.push(...updatedItems);
        });
    });
    updatedItems.forEach((item) => {
        client.setQueryData([`${DOWNLOAD_CACHE_KEY}:${uuid}`, { id: item.id }], item);
    });
    multiKeyValueMap(DOWNLOAD_CACHE_KEY, uuid, updatedItems)
        .forEach(([key, value]) => storage.set(key, value));
};
//# sourceMappingURL=onSuccessfulDownloadMutateCache.js.map